import { render, staticRenderFns } from "./CourseAgreementForm.vue?vue&type=template&id=57f20976&scoped=true"
import script from "./CourseAgreementForm.vue?vue&type=script&lang=js"
export * from "./CourseAgreementForm.vue?vue&type=script&lang=js"
import style0 from "./CourseAgreementForm.vue?vue&type=style&index=0&id=57f20976&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f20976",
  null
  
)

export default component.exports